import { useAppSessionStore } from '../stores';

export const useApp = () => {
  const {
    attachmentPreview,
    isCurrentlySelectedTabEmpty,
    isEmptySearch,
    isNotificationCenterVisible,
    isProfileVisible,
    setAttachmentPreview,
    setIsCurrentlySelectedTabEmpty,
    setIsEmptySearch,
    setIsNotificationCenterVisible,
    setIsProfileVisible,
  } = useAppSessionStore();

  return {
    attachmentPreview,
    isCurrentlySelectedTabEmpty,
    isEmptySearch,
    isNotificationCenterVisible,
    isProfileVisible,
    setAttachmentPreview,
    setIsCurrentlySelectedTabEmpty,
    setIsEmptySearch,
    setIsNotificationCenterVisible,
    setIsProfileVisible,
  };
};
